/* LSDJ V1. Presentation-only enhancement; no cart, product, discount or checkout writes. */
(() => {
 'use strict';
 if (window.__lsdjV1Loaded) return;
 window.__lsdjV1Loaded = true;
 const node = document.getElementById('LsdjV1Config');
 let config = {};
 try { config = JSON.parse(node?.textContent || '{}'); } catch (_) {}
 const priceSelector = '.f-price,.price,.money,[class*="__price"],[class*="__total"],.montage-acd__p,.f-badge--sale,[data-cart-subtotal]';
 const euroPattern = /(?<![\d.,])\d(?:[\d., \u00a0\u202f]*\d)?[ \u00a0\u202f]*(?:€|EUR\b)/g;
 function frenchPrice(text) {
  return text.replace(euroPattern, raw => {
   const compact = raw.replace(/(?:€|EUR)|[\s\u00a0\u202f]/g, '');
   const decimal = compact.match(/[.,](\d{1,2})$/);
   const whole = decimal ? compact.slice(0, -decimal[1].length - 1) : compact;
   const n = Number(whole.replace(/[.,]/g, '') + (decimal ? '.' + decimal[1] : ''));
   if (!Number.isFinite(n) || n > 1e12) return raw;
   const cents = Math.round(n * 100) % 100 !== 0;
   return new Intl.NumberFormat('fr-FR', {minimumFractionDigits:cents ? 2 : 0, maximumFractionDigits:2}).format(n) + '\u00a0€';
  });
 }
 const all = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
 function prices(root) {
  if (config.currency !== 'EUR') return;
  const targets = new Set(all(root, priceSelector));
  const parent = root.closest?.(priceSelector);
  if (parent) targets.add(parent);
  targets.forEach(target => {
   const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT, {acceptNode(t) {
    return t.parentElement?.closest('script,style,textarea,select,option,[contenteditable="true"]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
   }});
   let text;
   while ((text = walker.nextNode())) {
    if (!/€|EUR/.test(text.data)) continue;
    const formatted = frenchPrice(text.data);
    if (formatted !== text.data) text.data = formatted;
   }
  });
 }
 function mounting(root) {
  all(root, '.montage-acd__p--free').forEach(el => {if (el.textContent.trim() === 'Compris') el.textContent = 'Inclus';});
  all(root, '.montage-acd__panel,.montage-acd__zone').forEach(panel => {
   const walker = document.createTreeWalker(panel, NodeFilter.SHOW_TEXT);
   const texts=[]; let t;
   while ((t=walker.nextNode())) if (!t.parentElement.closest('a,script,style') && /sur devis/i.test(t.data)) texts.push(t);
   texts.forEach(text => {
    const parts = text.data.split(/(sur devis)/i); const fragment=document.createDocumentFragment();
    parts.forEach((part,i) => {
     if (i%2) {
      const a=document.createElement('a');
      const q=new URLSearchParams({motif:'montage',produit:config.productHandle || '',contexte:'montage-sur-devis'});
      a.href='/pages/contact?'+q.toString()+'#contact-form';a.textContent=part;
      fragment.appendChild(a);
     } else fragment.appendChild(document.createTextNode(part));
    });
    text.replaceWith(fragment);
   });
  });
 }
 function prepare(root) {
  all(root, '.lsdj-acd-differentiators__prepare li').forEach(li => {
   if (li.dataset.v1Prepared || li.children.length) return;
   const text=li.textContent.trim(); if(!text) return;
   const value=text[0].toLocaleUpperCase('fr')+text.slice(1);
   const match=value.match(/^(Un emplacement de niveau|Au moins deux personnes|Une ventilation et un ombrage)/i);
   if (match) {const strong=document.createElement('strong');strong.textContent=match[0];li.replaceChildren(strong,document.createTextNode(value.slice(match[0].length)));}
   else li.textContent=value;
   li.dataset.v1Prepared='true';
  });
 }
 /* Five complete slides, auto 1.5 s only on mobile. Interaction pauses rotation. */
 const carousels=new WeakMap();
 function carousel(root) {
  all(root, '[data-lsdj-v1-carousel]').forEach(el => {
   if (carousels.has(el)) return;
   const track=el.querySelector('[data-v1-track]');
   const slides=[...el.querySelectorAll('[data-v1-slide]')];
   const dots=[...el.querySelectorAll('[data-v1-dot]')];
   const pause=el.querySelector('[data-v1-pause]');
   if(!track || slides.length<2 || !pause) return;
   const mobile=matchMedia('(max-width: 767px)'), reduce=matchMedia('(prefers-reduced-motion: reduce)');
   const controller=new AbortController(), signal=controller.signal;
   let index=0,timer=0,inView=false,userPaused=reduce.matches,hover=false,focus=false;
   function state(){dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===index)));const label=userPaused?'Reprendre le défilement':'Mettre en pause';if(pause.textContent!==label)pause.textContent=label;pause.setAttribute('aria-pressed',String(userPaused));track.setAttribute('aria-live',userPaused?'polite':'off');}
   function sync(){clearInterval(timer);state();if(mobile.matches && inView && !document.hidden && !userPaused && !reduce.matches && !hover && !focus){timer=setInterval(()=>go(index+1,false),1500);}}
   function go(next,manual=true){index=(next+slides.length)%slides.length;if(manual)userPaused=true;track.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:reduce.matches?'instant':'smooth'});state();if(manual)sync();}
   dots.forEach((d,i)=>d.addEventListener('click',()=>go(i),{signal}));
   el.querySelector('[data-v1-prev]')?.addEventListener('click',()=>go(index-1),{signal});
   el.querySelector('[data-v1-next]')?.addEventListener('click',()=>go(index+1),{signal});
   pause.addEventListener('click',()=>{userPaused=!userPaused;sync();},{signal});
   track.addEventListener('pointerdown',()=>{userPaused=true;sync();},{signal,passive:true});
   track.addEventListener('scroll',()=>{let distance=Infinity;slides.forEach((s,i)=>{const d=Math.abs(s.offsetLeft-slides[0].offsetLeft-track.scrollLeft);if(d<distance){distance=d;index=i;}});state();},{signal,passive:true});
   el.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;sync();}},{signal});
   el.addEventListener('pointerleave',()=>{hover=false;sync();},{signal});
   el.addEventListener('focusin',()=>{focus=true;sync();},{signal});
   el.addEventListener('focusout',()=>{setTimeout(()=>{if(signal.aborted)return;focus=el.contains(document.activeElement);sync();},0);},{signal});
   document.addEventListener('visibilitychange',sync,{signal});
   mobile.addEventListener('change',sync,{signal});
   reduce.addEventListener('change',()=>{if(reduce.matches)userPaused=true;sync();},{signal});
   const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;sync();},{threshold:.35});observer.observe(el);
   carousels.set(el,()=>{clearInterval(timer);observer.disconnect();controller.abort();carousels.delete(el);});state();
  });
 }
 function enhance(root){if(!root?.querySelectorAll)return;prices(root);mounting(root);prepare(root);carousel(root);}
 function boot(){
  if(config.pageType==='page' && /profession|collectivit|b2b/.test(config.pageHandle || '')) document.getElementById('MainContent')?.classList.add('lsdj-v1-editorial');
  enhance(document);
  const queue=new Set();let scheduled=false;
  const observer=new MutationObserver(records=>{
   for(const record of records){
    if(record.type==='characterData')queue.add(record.target.parentElement);
    else for(const added of record.addedNodes) if(added.nodeType===1) queue.add(added); else if(added.nodeType===3)queue.add(added.parentElement);
   }
   if(scheduled || !queue.size)return;scheduled=true;
   requestAnimationFrame(()=>{scheduled=false;const roots=[...queue];queue.clear();roots.filter(r=>r?.isConnected).forEach(enhance);});
  });
  observer.observe(document.body,{subtree:true,childList:true,characterData:true});
  document.addEventListener('shopify:section:load',e=>enhance(e.target));
  document.addEventListener('shopify:section:unload',e=>all(e.target,'[data-lsdj-v1-carousel]').forEach(el=>carousels.get(el)?.()));
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
